import EditInvestCRMStrategyForm from './EditInvestCRMStrategyForm';

export default EditInvestCRMStrategyForm;
